import React from 'react';
import './Footer.css'; // Import styles if needed

const Footer = () => {
  return (
    <footer className="footer">
      <p>Sriumayaaltraders</p>
      <p>Email: sriumayaaltraders@gmail.com</p>   
    </footer>
  );
};

export default Footer;
